export default __webpack_public_path__ + "static/media/wegovy-drop-or-not.ee2b7a2b.mp4";